import { render, staticRenderFns } from "./leipzigKuchaStudiesPDFView.vue?vue&type=template&id=1011db2e&scoped=true"
import script from "./leipzigKuchaStudiesPDFView.vue?vue&type=script&lang=js"
export * from "./leipzigKuchaStudiesPDFView.vue?vue&type=script&lang=js"
import style0 from "./leipzigKuchaStudiesPDFView.vue?vue&type=style&index=0&id=1011db2e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011db2e",
  null
  
)

export default component.exports